import React from 'react';
import { Grid, Navbar, Row, Col } from 'react-bootstrap';
import DatasetSelector from '../dataset_selector';
import ShareSocialButtons from '../share_social_buttons';
import ReactDisqusThread from 'react-disqus-thread';

const Layout = (props) => {
  return (
    <div className="reactroot">
      <Navbar className="navbar-pf navbar-pf--light">
        <Navbar.Header>
          <Navbar.Brand>
            <a href="/"></a>
          </Navbar.Brand>
        </Navbar.Header>
        <div className="pull-right share-social-buttons-container">
          <ShareSocialButtons />
        </div>
      </Navbar>
      <div className="top-area">
        <Grid className="container-with-gradient__on-front">
          <h4><strong>Decision 2016</strong> - The Key Election Issues</h4>
          <h1><strong>40,000 americans</strong> share their opinion</h1>
          <h6>on presidential candidates, gun control, taxation and immigration</h6>
        </Grid>
      </div>
      <div className="results-container">
        <Grid className="container-with-gradient__on-front">
          <Row>
            <Col lg={7}>
              <div className="pf-select">
                <DatasetSelector />
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
      <Grid className="flex-container-lg">
        {props.children}
      </Grid>
      <div className="about-container">
        <Grid>
          <Row>
            <Col lg={8}>
              <div className="about-container__left-area">
                <h6>About <strong>Pollfish</strong></h6>
                <p>Pollfish's survey platform delivers online surveys globally
                  through mobile apps and the mobile web along with the desktop
                  web to ensure your survey reaches just the right audience
                  and provides the most cost effective and quickest survey results.</p>
                <a href="//pollfish.com/signup/researcher" target="_blank" className="about-container__link-button">Get insights for your own topics</a>
              </div>
            </Col>
            <Col lg={4}>
              <h6>In collaboration with</h6>
              <p>David Rothschild (<a href="//predictwise.com" target="_blank">www.predictwise.com</a>),
                Tobias Konitzer (<a href="//tkonitzer.com" target="_blank">www.tkonitzer.com</a>),
                and Sam Corbett-Davies, who explore bleeding edge methodology for translating raw
                polling data into accurate reflections of public opinion.</p>
            </Col>
          </Row>
        </Grid>
      </div>
      <Grid className="disqus-thread-container">
        <ReactDisqusThread
          shortname="https-www-pollfish-com-infographics"
          identifier={window.location.pathname}
          title={document.title}
          url={window.location.href} />
      </Grid>
      <footer>
        <Grid>
          <div className="clearfix">
            <div className="pull-left">© 2016 Pollfish. All Rights Reserved</div>
            <div className="pull-right">
              <ul className="list-inline">
                <li>
                  <a href="//pollfish.com/get-survey-responses-fast" target="_blank">Get survey responses</a>
                </li>
                <li>
                  <a href="//pollfish.com/contact" target="_blank">Contact Pollfish</a>
                </li>
              </ul>
            </div>
          </div>
        </Grid>
      </footer>
    </div>
  );
};

export default Layout;



/** WEBPACK FOOTER **
 ** ./src/components/layout/index.js
 **/